<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'

export default {
    init: payload => {
        payload.initTable()
        payload.filter()
    },
    methods: {
        filter: function () {
            this.isLoading = true
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.companies.filter}`,
                response => {
                    this.applyServerPage(response)

                    this.items.forEach(item => {
                        item.fullAddress = Common.concatAddress(item.address)
                    })

                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        selectItem(params) {
            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.companyObj }

            delete data.vgt_id
            delete data.originalIndex

            if (!data?.address?._id) {
                data.address = {}
            }

            this.data = data

            this.$bvModal.show('createCompanyModal')
        },
        initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.company.column.name'),
                    field: 'name',
                    width: '30%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.company.column.document'),
                    field: 'document',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.company.column.email'),
                    field: 'email',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.company.column.phone'),
                    field: 'primaryPhone',
                    type: 'phone',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.company.column.address'),
                    field: 'fullAddress',
                    type: 'text',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.company.column.creat.at'),
                    field: 'createDate',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.company.column.status'),
                    field: 'status',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: false,
                    filterable: false,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
